import { Text } from '@wix/design-system';
import React from 'react';
import { isClassicEditorHost } from '../../utils/get-editor-host';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const showErrorModal = async _ref => {
  let {
    title,
    content,
    primaryButtonText,
    secondaryButtonText,
    primaryButtonOnClick,
    secondaryButtonOnClick,
    a11yWizardAdapter,
    theme = 'destructive',
    editorHost
  } = _ref;
  const contentByHost = isClassicEditorHost(editorHost) ? content : /*#__PURE__*/React.createElement(Text, null, content);
  const modalProps = {
    content: contentByHost,
    onCloseButtonClick: () => secondaryButtonOnClick == null ? void 0 : secondaryButtonOnClick(),
    primaryButtonOnClick,
    primaryButtonText,
    secondaryButtonOnClick,
    secondaryButtonText,
    theme,
    title
  };
  if (isClassicEditorHost(editorHost)) {
    await a11yWizardAdapter.showDialog(modalProps);
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-error-modal.js.map